var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.value?.removed)?_c('div',{staticClass:"Node",class:{ dragging: _vm.dragging, selected: _vm.selected },style:({
		left: (_vm.value.x - 25) + 'px',
		top: (_vm.value.y - 25) + 'px',
		background: _vm.query?.color,
	}),on:{"mousedown":_vm.mousedown,"mouseover":function($event){return _vm.$emit('mouseover', $event)},"mouseout":function($event){return _vm.$emit('mouseout', $event)},"mouseup":_vm.mouseup}},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }